// extracted by mini-css-extract-plugin
export var banner = "style-module--banner--7f346";